<template>
  <b-navbar>
    <template slot="brand">
      <b-navbar-item href="/">
        <img
          src="@/assets/mks-logo-scaled.png"
          alt="Moore Kingston Smith Association Management"
        />
      </b-navbar-item>
    </template>
    <template slot="start">
      <b-navbar-item tag="router-link" :to="{ path: '/' }" exact>
        Home
      </b-navbar-item>
      <b-navbar-dropdown label="Tools" hoverable>
        <b-navbar-item tag="router-link" :to="{ path: 'gl-export' }">
          GL Export
        </b-navbar-item>
      </b-navbar-dropdown>
    </template>

    <template slot="end">
      <b-navbar-item tag="div">
        <div class="buttons">
          <b-button
            v-if="!isLoggedIn"
            tag="router-link"
            class="is-primary"
            :to="{ path: '/login' }"
          >
            Log In
          </b-button>
          <b-button v-else class="is-light" @click="logout">
            Logout - {{ getCurrentClient }}
          </b-button>
        </div>
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
export default {
  name: 'NavBar',
  components: {},
  data: function() {
    return {};
  },
  computed: {
    isLoggedIn: function() {
      return this.$store.getters.isLoggedIn;
    },
    getCurrentClient: function() {
      return this.$store.getters.currentClient;
    }
  },
  methods: {
    logout: function() {
      this.$store
        .dispatch('logout')
        .then(() => {
          this.$router.push('/login');
        })
        // TODO: handle errors where console.log currently is (app wide)
        // eslint-disable-next-line
        .catch(err => console.log(err));
    }
  }
};
</script>

<style></style>
